<div class="container py-5 text-center">
  <ng-container *ngIf="!failed; else punchoutLoginFailed">
    <i class="fa fa-spinner fa-spin fa-lg"></i>
    <h1 class="mt-3">{{ 'PUNCHOUT_LOGGING_IN' | translate }}</h1>
  </ng-container>
  <ng-template #punchoutLoginFailed>
    <i class="fa fa-exclamation-triangle fa-lg text-danger"></i>
    <h1 class="mt-3">{{ 'PUNCHOUT_LOGIN_FAILED' | translate }}</h1>
    <p class="mt-3">{{ 'PUNCHOUT_LOGIN_FAILED_DESCRIPTION' | translate }}</p>
  </ng-template>
</div>
